import { makeStyles } from 'tss-react/mui';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { OrderInfo } from 'adoms-common-lib';
import React from 'react';
import { BusinessDestinationInfo } from 'adoms-common-lib/build/model/OrderInfo/BusinessDestinationInfo';
import { BusinessRequesterInfo } from 'adoms-common-lib/build/model/OrderInfo/BusinessRequesterInfo';


const useStyles = makeStyles()((theme) => ({
    paper: {
        padding: '12px',
        textAlign: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));


/**
 * 受け取り人情報を表示する
 * @param props order
 */
export default function BusinessOrderRequesterInfo(props: any) {
    const { classes } = useStyles();
    const order = props.order as OrderInfo;
    const OrderRequesterInfo = props.order.requester as BusinessRequesterInfo
    return (
        <div>
            <Paper className={classes.paper} elevation={0}>
                <Typography variant="h5" component="div">
                    {OrderRequesterInfo.companyName} <br />{OrderRequesterInfo.lastname} {OrderRequesterInfo.firstname}様
                </Typography>
                <Typography variant="body1" component="div">
                    メールアドレス：{OrderRequesterInfo.mailaddress !== "" ? OrderRequesterInfo.mailaddress : "***"}
                </Typography>
                <Typography variant="body1" component="div">
                    電話番号：{OrderRequesterInfo.tel !== "" ? OrderRequesterInfo.tel : "***"}
                </Typography>
            </Paper>
        </div>
    );

}